import { ThemeConfig } from './types';

export const defaultTheme: ThemeConfig = {
  primaryColor: '#059669', // emerald-600
  secondaryColor: '#065f46', // emerald-800
  backgroundColor: '#f8fafc', // slate-50
  fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  borderRadius: '0.75rem' // rounded-xl
};
